import { State } from "@/store/modules/chat/index";
import { SpaceUserInterface } from "@/resources/interfaces/spaceUserInterfaces";
import { DefaultMessagingSession } from "amazon-chime-sdk-js";

const getUserChat = (state: State): SpaceUserInterface => {
  return state.userChat;
};

const getMessagingSession = (state: State): DefaultMessagingSession => {
  return state.messagingSession;
};

const getEndPointUrl = (state: State): string => {
  return state.endPointUrl;
};

const getChatType = (state: State): string => {
  return state.chatType;
};
const getMessages = (state: State) => {
  return state.messages;
};
const getUnSeenMessage = (state: State) => {
  return state.unSeenMessages;
};

const getNextToken = (state: State) => {
  return state.nextToken;
};

const getMinimizeChat = (state: State) => {
  return state.minimizeChat;
};

const getPinnedMessagesLength = (state: State) => {
  return state.pinnedMessagesLength;
};

export default {
  getUserChat,
  getMessagingSession,
  getEndPointUrl,
  getChatType,
  getMessages,
  getUnSeenMessage,
  getNextToken,
  getMinimizeChat,
  getPinnedMessagesLength,
};
